import { Link, useLocation } from "react-router-dom";
import { BadgeDollarSign } from "lucide-react";

export function PricingShortcut() {
  const location = useLocation();
  if (location.pathname !== "/") return null;
  return <Link className="fixed bottom-5 right-5 z-40 inline-flex items-center gap-2 rounded-full border border-slate-200 bg-white px-4 py-3 text-sm font-semibold text-slate-800 shadow-lg transition-colors hover:border-blue-300 hover:bg-blue-50" data-testid="pricing-shortcut" to="/pricing"><BadgeDollarSign size={17} className="text-blue-700"/>Plans & pricing</Link>;
}